import { TypePolicy } from '@apollo/client';

export const applicationTypePolicy: TypePolicy = {
  fields: {
    playlists: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
    publishedStations: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
  },
};
